import { render } from "./AVJSpage.vue?vue&type=template&id=24612f6a&scoped=true"
import script from "./AVJSpage.vue?vue&type=script&lang=js"
export * from "./AVJSpage.vue?vue&type=script&lang=js"

import "./AVJSpage.vue?vue&type=style&index=0&id=24612f6a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24612f6a"]])

export default __exports__